import {jwtServerInstance} from "../index";
import {getTokenUser} from "@/lib/utils";
import { status } from "nprogress";
import qs from	'qs'

export const getTaskOrders=(status, startTime, endTime, pagination) =>{
    return jwtServerInstance.request({
        url:'/b2ctaskorder/query',
        method:'post',
        data:qs.stringify({
            status: status,
            startTime: startTime,
            endTime: endTime,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const queryOrdersNum=() =>{
    return jwtServerInstance.request({
        url:'/b2ctaskorder/queryordernum',
        method:'post',
    })
}

export const queryAnchorTaskOrders=(pagination) =>{
    return jwtServerInstance.request({
        url:'/b2ctaskorder/queryanchor',
        method:'post',
        data:qs.stringify({
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const getOrderWithCustomer=(condition) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/condition',
        method: 'post',
        data: condition
    });
}

export const setRejectOrderShop=(orderInfo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/opertion',
        method: 'post',
        data: orderInfo
    });
}

export const batchReciveOrders=(orderInfo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/batchopertion',
        method: 'post',
        data: orderInfo
    });
}

export const reciveOrderWithAnchor=(orderInfo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/anchoropertion',
        method: 'post',
        data: qs.stringify({
            orderId:orderInfo.orderId,
            commission:orderInfo.commission
        })
    });
}

export const getReciveOrderDetail=(orderInfo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/detail',
        method: 'post',
        data: orderInfo
    });
}

export const cancelOrder=(orderInfo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/cancel',
        method: 'post',
        data: orderInfo
    });
}

export const getTaskCommont=(orderInfo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/taskcomm',
        method: 'post',
        data: orderInfo
    });
}


export const queryReviewCondition=(taskId) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/queryreviewcondition',
        method: 'post',
        data: qs.stringify({
            taskId: taskId
        })
    });
}

export const queryExtraReviewCondition=(taskId) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/queryextracondition',
        method: 'post',
        data: qs.stringify({
            taskId: taskId
        })
    });
}

export const checkShopName=(taskCommontVo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/verfiyshop',
        method: 'post',
        data: taskCommontVo
    });
}

export const checkGoodsLink =(taskCommontVo) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/verfiygoodlink',
        method: 'post',
        data: taskCommontVo
    });
}

export const commitOrderOperInfo =(b2cOperationTaskResult) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/opertionsetup',
        method: 'post',
        data: b2cOperationTaskResult
    });
}

export const commitReviewOperInfo =(data) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/reviewopt',
        method: 'post',
        data: qs.stringify({
            orderId: data.orderId,
            imageUrls: data.imageUrls
        })
    });
}

export const commitExtraReviewOperInfo =(data) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/reviewextraopt',
        method: 'post',
        data: qs.stringify({
            orderId: data.orderId,
            imageUrls: data.imageUrls
        })
    });
}

export const rejectExtraReviewOperInfo =(data) =>{
    return jwtServerInstance.request({
        url: '/taskservice/rejectextrareview',
        method: 'post',
        data: qs.stringify({
            orderId: data.id
        })
    });
}

export const queryExtraOrder =() =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/extraorder',
        method: 'post'
    });
}

export const commitAppealMessageInfo = (dialogForm) =>{
    return jwtServerInstance.request({
        url:'/b2cappealmessage/add',
        method:'post',
        data:dialogForm
    })
}

//参数配置列表查询接口
export const queryAppealList = (queryForm,pagination) => {
    return jwtServerInstance.request({
        url:'/b2cappealmessage/query',
        method:'post',
        data: qs.stringify({
            orderNumbers:queryForm.orderNumbers,
            userId:queryForm.userId,
            appealType:queryForm.appealType,
            appealStatus:queryForm.appealStatus,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

//新增判断是否存在催评
export const queryIsHavaPrompReview = () =>{
    return jwtServerInstance.request({
        url:'/b2corder/queryhavaprompstatus',
        method:'post'
    })
}


export const getAdminOrderVoList = (queryform, pagination) =>{
    return jwtServerInstance.request({
        url:'/b2corder/queryadminorderlist',
        method:'post',
        data:qs.stringify({
            status: queryform.status?queryform.status:"202305250003",
            startTime: queryform.startTime?queryform.startTime:null,
            endTime: queryform.endTime?queryform.endTime:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    })
}

export const changeOrderStatusApi =(data) =>{
    return jwtServerInstance.request({
        url: '/b2ctaskorder/update',
        method: 'post',
        data: qs.stringify({
            orderId: data.orderId,
            status: data.status,
            remarks: data.remarks
        })
    });
}

export const queryOrderNumberWithStatus =(data) =>{
    return jwtServerInstance.request({
        url: '/b2corder/queryordernums',
        method: 'post'
    });
}


